// @ts-ignore
import BackgroundVideo from'./images/bg.mp4';export const VIDEOS={BACKGROUND:BackgroundVideo};